import { render, staticRenderFns } from "./viewModel.vue?vue&type=template&id=a27edc84&scoped=true"
import script from "./viewModel.vue?vue&type=script&lang=js"
export * from "./viewModel.vue?vue&type=script&lang=js"
import style0 from "./viewModel.vue?vue&type=style&index=0&id=a27edc84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27edc84",
  null
  
)

export default component.exports